import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		title: {
			marginBottom: theme.spacing(2.2),

			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ metaData }) => metaData.mobileAlignment?.metaValue,
				},
			},
		},
		buttonWrap: {
			width: '100%',
			display: 'flex',
			justifyContent: ({ metaData }) =>
				metaData.mobileButtonWidth?.isWide ? null : metaData.mobileAlignment?.contentAlignment(),
		},

		button: {
			width: theme.spacing(32.5),
			marginTop: theme.spacing(3.5),
			marginBottom: theme.spacing(0),

			[theme.breakpoints.down('xs')]: {
				width: ({ metaData }) => (metaData.mobileButtonWidth?.isWide ? '100%' : 'auto'),
				marginBottom: theme.spacing(2.5),
				marginTop: theme.spacing(2.5),
			},
		},
		itemTitle: {
			marginBottom: theme.spacing(1),
		},
		empty: {
			display: 'none',
			[theme.breakpoints.up('lg')]: {
				display: 'block',
			},
		},
	}),
	{ name: 'Category-Category5' },
)

export default useStyles
